import { useState } from "react";

import { Editor } from "primereact/editor";

const EditorPage = () => {
  const [text, setText] = useState();

  return (
    <>
      <div class="container">
        <section class="section">
          <Editor
            value={text}
            onTextChange={(e) => setText(e.htmlValue)}
            style={{ height: "500px" }}
          />
          <textarea readOnly value={text} rows={30} className="box w-full" />
        </section>
      </div>
    </>
  );
};

export default EditorPage;
